import React, { useEffect, useState } from "react";
import { TraitementService } from "../Services/TraitementService";
import {
  Button,
  Col,
  DatePicker,
  Input,
  Row,
  Select,
  Space,
  Table,
  Typography,
  message,
} from "antd";
import moment from "moment";
import "../Pages/CSS/Traitement.css";

import dayjs from "dayjs";
import { PlanComptService } from "../Services/PlanComptService";
import { JournalCentralService } from "../Services/JournalCentralService";
import { EtatComptaService } from "../Services/EtatComptaService";
import { printEtatComptService } from "../Services/PrintEtatComptService";
import { PrinterOutlined, BarChartOutlined } from "@ant-design/icons";
const getSelectedYear = () => {
  const currentYear = new Date().getFullYear();
  return currentYear.toString();
};

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Title } = Typography;



const EtatComptaFin = () => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [exercices, setExercices] = useState([]);
  const [societes, setSocietes] = useState([]);
  const [refetch, setRefetch] = useState(null);
  const [balanceType, setBalanceType] = useState("");
  const [isVisualized, setIsVisualized] = useState(false);
  const [journaux, setJournaux] = useState([]);
  const [selectedJournaux, setSelectedJournaux] = useState("ALL");
  const [etatLabel, setEtatLabel] = useState("");
  const [nbcol, setNbcol] = useState(6);
  const [pageSize, setPageSize] = useState(10)
  const [niveau, setNiveau] = useState(0);
  const [etat, setEtat] = useState("");
  const [tiers, setTiers] = useState("");
  const [typeBalance, setTypeBalance] = useState("");
  const [typeGrandLivre, setTypeGrandLivre] = useState("Selectionner");
  const [compteDeb, setCompteDeb] = useState("");
  const [compteFin, setCompteFin] = useState("");

  const [dateDeb, setDateDeb] = useState(null);
  const [dateFin, setDateFin] = useState(null);
  const [tableData, setTableData] = useState([]);
  const traitementFactureService = new TraitementService();
  const plancomptaService = new PlanComptService();
  const journalCentralService = new JournalCentralService();
  const listExportComptaService = new EtatComptaService();


  useEffect(() => {
    const fetchData = async () => {
      try {
        const planCompta = await plancomptaService.getAllPlanCompta();
        setSocietes(planCompta);

        const journauxData = await journalCentralService.getList();
        setJournaux(journauxData);

        const exercicesData = await traitementFactureService.getExercices();
        setExercices([...exercicesData].sort((a, b) => b - a));

        const paramData = await traitementFactureService.getParamComptable(); // Assuming you will use the data later
        const yearFromParamData = dayjs(paramData.datedeb).format("YYYY");
        setSelectedYear(yearFromParamData)
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      setDateDeb(new Date(parseInt(selectedYear), 0, 1));
      setDateFin(new Date(parseInt(selectedYear), 11, 31));
    }
  }, [selectedYear]);

  const onchangePrestation = (value) => {
    setSelectedJournaux(value);
  };

  const handleEtatChange = (value, option) => {
    setEtat(value);
    setEtatLabel(option.children);
    // Réinitialiser les états dépendants lorsque l'état principal change
    setTypeBalance("");  // Réinitialise typeBalance chaque fois que l'état change
    setTypeGrandLivre("");  // Réinitialise typeGrandLivre chaque fois que l'état change
    setTiers("");  // Réinitialiser les tiers pour éviter les restes d'anciens états
    setCompteDeb("");  // Réinitialiser compteDeb
    setCompteFin("");  // Réinitialiser compteFin

    // Ajoutez d'autres réinitialisations si nécessaire
  };


  const handleYearChange = (value) => {
    setSelectedYear(value);
    console.log(value);
    setDateDeb(new Date(value, 0, 1));
    setDateFin(new Date(value, 11, 31));
    setRefetch(Date.now());
    console.log(dateDeb);
  };

  const monthName = (monthNumber) => {
    const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    return months[monthNumber - 1];
  };

  const handleExport = async () => {
    const codeExport = handleButtonState().code;
    await listExportComptaService.exportCompta(codeExport)

  };

  const handlePrint = async () => {
    const codeExport = handleButtonState().code;
    const formattedDateDeb = moment(dateDeb).format("YYYY-MM-DD");
    const formattedDateFin = moment(dateFin).format("YYYY-MM-DD");

    try {
      printEtatComptService(codeExport, selectedYear, selectedJournaux, formattedDateDeb, formattedDateFin, nbcol, niveau, compteDeb, compteFin); // déclenche l'impression

      message.success("Les documents sont en cours d'impression.");
    } catch (error) {
      console.error("Erreur lors de l'impression :", error);
      message.error("Une erreur est survenue lors de l'impression.");
    }
  };


  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }


  const handleButtonState = () => {
    let result = true;
    let code = null;

    if (!etat || !dateDeb || !dateFin) {
      return { code, result: true };  // Empêche le bouton de s'activer si les champs nécessaires ne sont pas remplis
    }

    switch (etat) {
      case "ceg":
        code = "ceg";
        result = false;
        break;
      case "cet":
        code = "cet";
        result = false;
        break;
      case "balance":
        if (typeBalance === "blg") {
          code = "blg";
          result = false;
        } else if (typeBalance === "tiersvalue") {
          if (tiers === "bltp" || tiers === "bltf") {
            code = tiers;  // Utilise le choix de tiers comme code
            result = false;
          } else {
            result = true;  // Désactive le bouton si aucun choix spécifique n'est fait
          }
        }
        break;
      case "book":
        if (typeGrandLivre === "glg") {
          code = "glg";
          result = false;
          if (compteDeb === "compte") {
            code = compteDeb;
            result = false;
          } else if (compteFin === "compte") {
            code = compteFin;
            result = false;
          }

        } else if (typeGrandLivre === "tiersvalu") {
          if (tiers === "gltt" || tiers === "gltp" || tiers === "gltf") {
            code = tiers;
            result = false;
          } else {
            result = true;
          }
        }
        break;
      default:
        result = true;
        break;
    }

    return { code, result };
  }


  const handleVisualizeClick = async () => {
    if (!etat || !dateDeb || !dateFin) {

      alert(
        "Veuillez sélectionner tous les champs nécessaires avant de visualiser."
      );
      return;
    }
    const dataExport = {
      codeExport: handleButtonState().code,
      codej: selectedJournaux,
      compteDeb: compteDeb,
      compteFin: compteFin,
      dateDeb: dateDeb,
      dateFin: dateFin,
    };
    try {
      const result = await listExportComptaService.listEtatComptaExport(
        dataExport
      );
      setTableData(result);
      setIsVisualized(true);
      console.log("Résultats de l'exportation :", result);

    } catch (error) {
      console.error("Erreur lors de la visualisation des données :", error);
      alert("Erreur lors de la récupération des données. Veuillez réessayer.");
    }
  };

  const handleResetClick = () => {
    setIsVisualized(false);
    setTableData([]);
    setEtat("");
    setTypeBalance("");
    setTypeGrandLivre("");
    setCompteDeb("");
    setCompteFin("");
    setTiers("");
    setSelectedJournaux("ALL");
  };


  const handleTypeBalanceChange = (value) => {
    console.log(value);
    setTypeBalance(value);
    setBalanceType(value === "blg" ? "Général" : value === "tiersvalue" ? "Tiers" : "");
  };
  const handleTypeGLChange = (value) => {
    console.log(value);
    setTypeGrandLivre(value);
    setBalanceType(value === "glg" ? "Général" : value === "tiersvalu" ? "Tiers" : "");
  };

  const handleTypeTiersChange = (value) => {
    console.log(value);
    setTiers(value);
  };

  const calculateTotals = () => {
    let totalDebit = 0;
    let totalCredit = 0;

    tableData.forEach((item) => {
      totalDebit += parseFloat(item.debit || 0);
      totalCredit += parseFloat(item.credit || 0);
    });

    const solde = totalDebit - totalCredit;

    return { totalDebit, totalCredit, solde };
  };


  const { totalDebit, totalCredit, solde } = calculateTotals();

  const getColumns = () => {
    const commonColumns = [
      {
        title: "C.JL",
        dataIndex: "codej",
        key: "codej",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            tableData.map((item) => item?.codej).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.codej === value,
      },
      {
        title: "Date Pièce",
        dataIndex: "datepiece",
        key: "datepiece",
        align: "center",
        sorter: (a, b) => {
          const dateA = moment(a.datepiece, "YYYY-MM-DD", true);
          const dateB = moment(b.datepiece, "YYYY-MM-DD", true);
          if (!dateA.isValid() && !dateB.isValid()) return 0;
          if (!dateA.isValid()) return 1;
          if (!dateB.isValid()) return -1;
          return dateA.unix() - dateB.unix();
        },
        sortDirections: ["ascend", "descend"],
        render: (text) => {
          const date = moment(text, "YYYY-MM-DD", true);
          return date.isValid() ? date.format("DD/MM/YYYY") : "";
        },
      },
      {
        title: "N° pièce",
        dataIndex: "numpiece",
        key: "numpiece",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            tableData.map((item) => item?.numpiece).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.numpiece === value,
      },
      {
        title: "Cpte. Gen.",
        dataIndex: "comptegen",
        key: "comptegen",
        align: "center",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8, width: 200 }}>
            {/* Recherche personnalisée */}
            <Input
              placeholder="Rechercher..."
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys([e.target.value])}
              onPressEnter={() => confirm()}
              style={{ marginBottom: 8 }}
            />

            {/* Boutons */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={() => {
                  clearFilters();
                  confirm();
                }}
                size="small"
                style={{ width: "48%" }}
              >
                Reset
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: "48%" }}
              >
                Ok
              </Button>
            </div>
          </div>
        ),
        filters: [
          ...new Set(
            tableData.map((item) => item?.comptegen).filter((value) => value) // Éliminer les valeurs `null` ou `undefined`
          )
        ].map((value) => ({
          text: value,
          value: value,
        })),
        onFilter: (value, record) => record.comptegen === value,
      },
      {
        title: "Cpte. Cipres.",
        dataIndex: "cptecipres",
        key: "cptecipres",
        align: "center",
      },
      { title: "Cpte. Tiers", dataIndex: "comptetiers", key: "comptetiers" },
      {
        title: "Libellé",
        dataIndex: etat === 'balance' || etat === 'book' ? 'libelle' : 'intitule',
        key: etat === 'balance' || etat === 'book' ? 'libelle' : 'intitule',
      },



      {
        title: "Mvts Débit",
        dataIndex: "debit",
        key: "debit",
        align: "right",
        render: (text) => <div style={{ paddingRight: 10 }}><strong>{text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}</strong></div>,
      },
      {
        title: " Mvts Crédit",
        dataIndex: "credit",
        key: "credit",
        align: "right",
        render: (text) => <div style={{ paddingRight: 10 }}><strong>{text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}</strong></div>,
      },
    ];


    if (etat === 'cet' || etat === 'ceg') {
      commonColumns.splice(3, 0, {
        title: "Exercice",
        dataIndex: "exercice",
        key: "exercice",
        align: "center",
      });
      commonColumns.splice(4, 0, {
        title: "Mois",
        dataIndex: "mois",
        key: "mois",
        align: "center",
        render: (mois) => monthName(mois)
      });
    }

    if (etat === 'cet' || etat === 'ceg') {
      commonColumns.splice(3, 0, {
        title: "Exercice",
        dataIndex: "exercice",
        key: "exercice",
        align: "center",
      });
      commonColumns.splice(4, 0, {
        title: "Mois",
        dataIndex: "mois",
        key: "mois",
        align: "center",
        render: (mois) => monthName(mois)
      });
    }
    if (etat === 'balance') {
      commonColumns.splice(7, 0, {

        title: "Solde Débit N-1",
        dataIndex: "debit_ant",
        key: "debit_ant",
        align: "right",
        render: (text) => <div style={{ paddingRight: 10 }}>{text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}</div>,

      });
      commonColumns.splice(8, 0, {
        title: "Solde  Crédit N-1",
        dataIndex: "credit_ant",
        key: "credit_ant",
        align: "right",
        render: (text) => <div style={{ paddingRight: 10 }}>{text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}</div>,
      },);
      commonColumns.splice(13, 0, {
        title: " Solde Débit N",
        dataIndex: "solde_debit",
        key: "solde_debit",
        align: "right",
        render: (text) => <div style={{ paddingRight: 10 }}><strong>{text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}</strong></div>,
      },);
      commonColumns.splice(12, 0, {
        title: "Solde Crédit N",
        dataIndex: "solde_credit",
        key: "solde_credit",
        align: "right",
        render: (text) => <div style={{ paddingRight: 10 }}><strong>{text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}</strong></div>,
      },);

    }

    return commonColumns;
  };

  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <BarChartOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Etats Comptables & Financiers
        </span>
      </div>
      <Row gutter={16} style={{ marginBottom: "16px" }}>
        <Col span={16}>
          <Space direction="vertical" style={{ textAlign: "left" }}>
            <label>Exercice</label>
            <Select
              className="select-colored-accent"
              style={{
                width: 90,
                marginRight: 10,
                "--select-accent": "#1890ff",
                "--select-accent-bg": "#e6f4ff",
                "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
              }}
              onChange={handleYearChange}
              value={selectedYear}
            >
              {exercices.map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Space>
          <Space direction="vertical" style={{ textAlign: "left" }}>
            <label>Période</label>
            <RangePicker
              format="DD/MM/YYYY"
              value={[dayjs(dateDeb), dayjs(dateFin)]}
              onChange={(dates) => {
                if (dates && dates.length === 2) {
                  setDateDeb(dates[0].toDate());
                  setDateFin(dates[1].toDate());
                  setRefetch(Date.now()); // Utiliser setRefetch pour forcer un rechargement des données
                }
              }}
            />
          </Space>
        </Col>
        <Col span={8} style={{ display: "flex", justifyContent: "end" }}>
          <span style={{ paddingTop: 25 }}>
            <Button
              className="buttonExport"
              onClick={handleVisualizeClick}
              // disabled={!etat} 
              disabled={handleButtonState().result}
            >
              Visualiser
            </Button>
          </span>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: "16px" }}>
        <Col span={24}>
          <Space>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Journal</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 300,
                  "--select-accent": "#52c41a",
                  "--select-accent-bg": "#f6ffed",
                  "--select-accent-shadow": "rgba(82, 196, 26, 0.25)",
                }}
                defaultValue={selectedJournaux}
                onChange={onchangePrestation}
              >
                <Select.Option value="ALL">Tous les journaux</Select.Option>
                {journaux.map((journal) => (
                  <Option key={journal.codej} value={journal.codej}>
                    {journal.codej} - {journal.libelle}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Etat</label>
              <Select
                value={etat}
                onChange={(value, option) => handleEtatChange(value, option)}
                placeholder="Etat"
                className="select-colored-accent"
                style={{
                  width: 300,
                  "--select-accent": "#fa8c16",
                  "--select-accent-bg": "#fff7e6",
                  "--select-accent-shadow": "rgba(250, 140, 22, 0.25)",
                }}
              >
                <Option value="cet">Compte Exploitation Technique</Option>
                <Option value="ceg">Compte Exploitation Générale</Option>
                <Option value="balance">Balance</Option>
                <Option value="book">Grand Livre</Option>
              </Select>
            </Space>
          </Space>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          {etat === "balance" && (
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Type</label>
              <Select
                className="select-colored-accent"
                value={typeBalance}
                style={{
                  width: 120,
                  marginRight: 16,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                onChange={handleTypeBalanceChange}
              >
                <Option value="blg">Général</Option>
                <Option value="tiersvalue">Tiers</Option>
              </Select>
            </Space>
          )}
          {/* {typeBalance === 'blg' && (
        <>
         <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Type d'État</label>
          <Select value={nbcol}
      onChange={(value) => setNbcol(value)}  
          
          style={{ width: 120, marginRight: 16 }}  >
            <Option value="6">6 colonnes</Option>
            <Option value="4">4 colonnes</Option>
          </Select>
          </Space>
          <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Niveau</label>
          <Select 
          value={niveau}
          onChange={(value) => setNiveau(value)}    style={{ width: 120, marginRight: 16 }}  >
            <Option value={0}>0</Option>
            <Option value={1}>1</Option>
            <Option value={2}>2</Option>
            <Option value={3}>3</Option>
          </Select>
         </Space>
        </>
      )} */}
          {typeBalance === 'tiersvalue' && (
            <>
              <Space
                direction="vertical"
                style={{ marginRight: 12, textAlign: "left" }}
              >
                <label>Tiers</label>
                <Select
                  className="select-colored-accent"
                  defaultValue=""
                  style={{
                    width: 120,
                    marginRight: 16,
                    "--select-accent": "#13c2c2",
                    "--select-accent-bg": "#e6fffb",
                    "--select-accent-shadow": "rgba(19, 194, 194, 0.25)",
                  }}
                  value={tiers}
                  onChange={handleTypeTiersChange}
                >
                  <Option value="bltp">Participant</Option>
                  <Option value="bltf">Fournisseur</Option>
                </Select>
              </Space>
              <Space
                direction="vertical"
                style={{ marginRight: 12, textAlign: "left" }}
              >
                {/* <label>Type d'État</label>
                <Select value={nbcol}
                  onChange={(value) => setNbcol(value)} style={{ width: 120, marginRight: 16 }}  >
                  <Option value="6">6 colonnes</Option>
                  <Option value="4">4 colonnes</Option>
                </Select> */}
              </Space>
            </>
          )}
          {etat === "book" && (
            <Space
              direction="vertical"
              style={{ marginRight: 12, textAlign: "left" }}
            >
              <label>Type de Grand Livre</label>
              <Select
                className="select-colored-accent"
                value={typeGrandLivre}
                style={{
                  width: 120,
                  marginRight: 16,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                onChange={handleTypeGLChange}
              >

                <Option value="glg">Général</Option>
                <Option value="tiersvalu">Tiers</Option>
              </Select>
            </Space>
          )}
          {typeGrandLivre === 'glg' && (
            <>
              <Space
                direction="vertical"
                style={{ marginRight: 12, textAlign: "left" }}
              >
                <label>compte N° de...</label>
                <Select
                  placeholder="compte N° de..."
                  value={compteDeb}
                  onChange={(value) => setCompteDeb(value)}
                  className="select-colored-accent"
                  style={{
                    width: 300,
                    marginRight: 16,
                    "--select-accent": "#1890ff",
                    "--select-accent-bg": "#e6f4ff",
                    "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                  }}
                  allowClear  // Permet de réinitialiser le sélecteur en affichant une petite croix
                  showSearch
                  onInputKeyDown={(e) => {
                    if ((e.key === "Enter" || e.key === "Tab") && e.target.value) {
                      setCompteDeb(e.target.value);  // Enregistre la valeur saisie
                      e.preventDefault();  // Empêche le comportement par défaut du select
                    }
                  }}

                >
                  <Option value="">Tous les comptes</Option>  // Cette option sera visible seulement après ouverture du select
                  {societes.map((societe) => (
                    <Option key={societe.compte} value={societe.compte}>{societe.compte} - {societe.intitule}</Option>
                  ))}
                </Select>
              </Space>
              <Space
                direction="vertical"
                style={{ marginRight: 12, textAlign: "left" }}
              >
                <label>compte N° à...</label>
                <Select
                  placeholder="compte N° à..."
                  value={compteFin}
                  onChange={(value) => setCompteFin(value)}
                  className="select-colored-accent"
                  style={{
                    width: 300,
                    marginRight: 16,
                    "--select-accent": "#1890ff",
                    "--select-accent-bg": "#e6f4ff",
                    "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                  }}
                  allowClear
                  showSearch
                  onInputKeyDown={(e) => {
                    if ((e.key === "Enter" || e.key === "Tab") && e.target.value) {
                      setCompteFin(e.target.value);  // Enregistre la valeur saisie
                      e.preventDefault();  // Empêche le comportement par défaut du select
                    }
                  }}
                >
                  <Option value="">Tous les comptes</Option>
                  {societes.map((societe) => (
                    <Option key={societe.compte} value={societe.compte}>{societe.compte} - {societe.intitule}</Option>
                  ))}
                </Select>
              </Space>
            </>
          )}

          {typeGrandLivre === 'tiersvalu' && (
            <>
              <Space
                direction="vertical"
                style={{ marginRight: 12, textAlign: "left" }}
              >
                <label>Tiers</label>
                <Select
                  className="select-colored-accent"
                  defaultValue=""
                  style={{
                    width: 120,
                    marginRight: 16,
                    "--select-accent": "#13c2c2",
                    "--select-accent-bg": "#e6fffb",
                    "--select-accent-shadow": "rgba(19, 194, 194, 0.25)",
                  }}
                  value={tiers}
                  onChange={handleTypeTiersChange}
                >
                  <Option value="gltt">Tous</Option>
                  <Option value="gltp">Participant</Option>
                  <Option value="gltf">Fournisseur</Option>
                </Select>
              </Space>
            </>
          )}
        </Col>
      </Row>
      {isVisualized && (
        <>
          <Space style={{ display: "flex", justifyContent: "space-between" }}>
            <span>
              <Title level={4}>
                <strong>Tous les journaux ({etatLabel} - {etat === "balance" || etat === "book" ? `${balanceType}` : ""})</strong>
              </Title>
              <span>
                Total: Débit <strong>{totalDebit.toLocaleString()} </strong> - Crédit{" "}
                <strong> {totalCredit.toLocaleString()}</strong> - Solde <strong>{solde.toLocaleString()}</strong>
              </span>
            </span>
            <Space>
              <Button className="buttonClose" onClick={handleResetClick}>Fermer</Button>
              <Button className="buttonExport" onClick={handleExport}>Exporter en Excel</Button>
              <Button icon={<PrinterOutlined />}
                className="buttonImprim"
                onClick={handlePrint}>Imprimer</Button>
            </Space>
          </Space>
          <Table
            columns={getColumns()}
            showSorterTooltip={false}
            dataSource={tableData}
            scroll={{
              x: true,
            }}
            style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            // className="custom-header1-table"
            className="custom-header2-table my-custom-table"
            /*  rowClassName={(record) =>
               selectedRowKeys.includes(record.numligne) ? "selected-row" : ""
             } */
            bordered
            pagination={{
              pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
              showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
              pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
              onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
            }}
          />
        </>
      )}
    </div>
  );
};

export default EtatComptaFin;
